/**
 * Server-controlled Sentry configuration
 * These settings can be toggled on/off from the server without code changes
 */
export interface SentryServerConfig {
	/**
	 * Enable session replay recording
	 */
	enableSessionReplay: boolean;

	/**
	 * Sample rate for session replays (0.0 - 1.0)
	 * 0.1 = 10% of sessions recorded
	 */
	sessionReplaySampleRate: number;

	/**
	 * Sample rate for session replays on error (0.0 - 1.0)
	 * 1.0 = record 100% of sessions with errors
	 */
	replaysOnErrorSampleRate: number;

	/**
	 * Sample rate for transaction tracing (0.0 - 1.0)
	 */
	tracesSampleRate: number;

	/**
	 * Enable error capturing
	 */
	enableErrorCapture: boolean;

	/**
	 * Enable performance monitoring
	 */
	enablePerformanceMonitoring: boolean;

	/**
	 * URLs for trace propagation targets (for distributed tracing)
	 */
	tracePropagationTargets?: string[];

	/**
	 * Custom metadata or flags for future feature toggles
	 */
	features?: Record<string, boolean>;
}

/**
 * Default Sentry config values when server config is unavailable
 */
export const DEFAULT_SENTRY_CONFIG: SentryServerConfig = {
	enableSessionReplay: true,
	sessionReplaySampleRate: 0.1,
	replaysOnErrorSampleRate: 1.0,
	tracesSampleRate: 0.2,
	enableErrorCapture: true,
	enablePerformanceMonitoring: true,
	features: {},
};

/**
 * Sentry initialization options after fetching server config
 */
export interface SentryInitConfig {
	dsn: string;
	environment: string;
	serverConfig: SentryServerConfig;
}
